import script from "./AddNewPopUp.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewPopUp.vue?vue&type=script&setup=true&lang=js"

import "./AddNewPopUp.vue?vue&type=style&index=0&id=535c103a&lang=css"

const __exports__ = script;

export default __exports__